module.exports = __webpack_public_path__ + "static/media/kris.22d14110.webp";